import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BaseListComponent } from '../../../../../../components/base-list.component';
import { BsModalService } from 'ngx-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { TicketService } from '../../../../../../common/services/Ticket.service';
import { ContactService } from '../../../../../../common/services/Contact.service';
import { UserService } from '../../../../../../common/services/User.service';
import { SearchService } from '../../../../../../common/services/Search.service';
import { UsersConst } from './users.const';
import { AgentConst } from '../../../setting/expert/agent/agent.const';

@Component({
  selector: 'detail-organize-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.css', '../../../../../../../css/fuck.css', '../../../search/search.css'],
  providers: [TicketService, ContactService, UserService, SearchService],
})
export class UsersComponent extends BaseListComponent {
  @Input() organize_id: any = null;
  @Output() onOpenUser: EventEmitter<any> = new EventEmitter();
  constructor(
    protected changeDetector: ChangeDetectorRef,
    protected modalService: BsModalService,
    protected toastr: ToastrService,
    private userService: UserService
  ) {
    super(changeDetector, toastr, modalService);
    this.displayColumns = UsersConst.displayColumns();
  }

  async ngOnInit() {
    await this.loadData();
  }

  async loadData(request: any = {}, sort: any = {}) {
    request.filters = JSON.stringify([
      {
        key: 'organize_id',
        condition: '=',
        value: this.organize_id,
      },
    ]);
    const payload = await this.buildBasePayload(request, sort);
    this.userService.list(payload).subscribe(res => {
      if (res.status == 200 && !res.error) {
        this.data = res.data.list;
        this.data = this.data.map(e => {
          e.display_role = AgentConst.displayRoleColumns(e, this.user._id);
          e.display_active = AgentConst.displayActiveColumns(e);
          e.status = e.active;
          return e;
        });
        this.initPage(res.data.total);
      } else {
        this.data = [];
      }
    });
  }

  async openUser(user: any) {
    this.onOpenUser.emit({ data: user });
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/tabs/organize/users/users.component.ts